export enum Permissions {
  AccessCreateRequestMenu = 'AccessCreateRequestMenu',
  AccessExternalHomePage = 'AccessExternalHomePage',

  AccessControlPanelMenu = 'AccessControlPanelMenu',
  AccessControlPanelUsersMenu = 'AccessControlPanelUsersMenu',
  AccessControlPanelCompaniesMenu = 'AccessControlPanelCompaniesMenu',

  AccessUserParentMenu = 'AccessUserParentMenu',

  AccessRequestsListView4Customers = 'AccessRequestsListView4Customers',
  AccessRequestsListView4Internals = 'AccessRequestsListView4Internals',
  AccessCustomersRequestsList = 'AccessCustomersRequestsList',
  AccessAssignedUserRequestsList = 'AccessAssignedUserRequestsList',
  AccessAllRequestsList = 'AccessAllRequestsList',

  AccessToToolbar = 'AccessToToolbar',
  AccessToEditAll = 'AccessToEditAll',
  AccessToShowAssignedUser = 'AccessToShowAssignedUser',
  AccessToChangeStatus = 'AccessToChangeStatus',
  AccessToPrintProcessFields = 'AccessToPrintProcessFields',
  AccessToFileDetails = 'AccessToFileDetails',
  AccessToWaiveSlaFee = 'AccessToWaiveSlaFee',
  AccessToSpecialHandling = 'AccessToSpecialHandling',

  AccessToFileDetailsToolbar = 'AccessToFileDetailsToolbar',
  AccessToChangeFileStatus = 'AccessToChangeFileStatus',
  AccessToShowFileLink = 'AccessToShowFileLink',

  AccessToAddOrEditUsers = 'AccessToAddOrEditUsers',
  AccessToAddOrEditCompanies = 'AccessToAddOrEditCompanies',
  AccessToEditUsers = 'AccessToEditUsers',

  AccessDiagnosticPage = 'AccessDiagnosticPage',
}
